/***


	(sep 25)


		[ ] aanpassen voor nieuwe app


*/
import Navbar 				from "./components/Navbar";
import Home 				from "./pages/Home";
import Dashboard 			from "./pages/Dashboard";
import Login 				from "./pages/Login";
import PasswordReset		from "./pages/PasswordReset";
import SignUp 				from "./pages/SignUp";


import React, { useEffect, useRef, useState } from 'react';

import { Route, Routes, Navigate } 	from "react-router-dom"

import { AuthProvider } 	from './context/AuthContext';
import { 
	auth 
} 								from "./utils/firebase";
import { 
	useAuthState 
} 								from "react-firebase-hooks/auth";



function App() {

	/***
		Auth
		====
	*/

	const [user, loading] 			= useAuthState(auth);
	// const [token, setToken] 		= useState('');

	// Optioneel: wacht tot Firebase auth geladen is
	// if (loading) {
	// 	return <div className="text-center mt-20">Laden...</div>;
	// }






  	return (

		<div className="page-wrapper">

			<AuthProvider>

				<Navbar />
			
				<div className="container">
					<Routes>


						{/* Root route afhankelijk van loginstatus */}
						<Route
							path			="/"
							element			={user ? <Dashboard /> : <Login />}
						/>


						{/* Beschermde route voor dashboard */}
						<Route
							path			="/dashboard"
							element			={
												user 
												? <Dashboard /> 
												: <Navigate to="/login" replace />
											}
						/>


						<Route path="/login" 				element={<Login />} />
						<Route path="/signup" 				element={<SignUp />} />
						<Route path="/passwordReset"		element={<PasswordReset />} />
					
					
					</Routes>
				</div>

				{/* <h1> COMING SOON </h1> */}

				{/* <div className="footer">
					
				</div> */}
			
			</AuthProvider>
		</div>
  	)
}

export default App